import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import type { GetAiPredictionsInDateRangeApiResponse } from '~/redux/modules/tic/api-slice/GENERATED_ARTIFACT';

export interface TicPredictionsState {
  dates_updated_at: GetAiPredictionsInDateRangeApiResponse['meta']['dates_updated_at'];
}
type UpdatePredictionsMetaPayload = Pick<TicPredictionsState, 'dates_updated_at'>;

const initialState: TicPredictionsState = {
  dates_updated_at: {},
};

const ticPredictionsSlice = createSlice({
  name: 'ticPredictions',
  initialState,
  // TODO: Reconsider this code/place of implementation now that stats have their own endpoint
  reducers: {
    updatePredictionsMeta: (state, { payload }: PayloadAction<UpdatePredictionsMetaPayload>) => {
      state.dates_updated_at = { ...state.dates_updated_at, ...payload.dates_updated_at };
    },
  },
  selectors: {
    getPredictionsMeta: (state: TicPredictionsState) => {
      const { dates_updated_at } = state;
      return { dates_updated_at };
    },
  },
});

export const { updatePredictionsMeta } = ticPredictionsSlice.actions;
export const { getPredictionsMeta } = ticPredictionsSlice.selectors;

export default ticPredictionsSlice.reducer;
